import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MarkdownModule } from 'ngx-markdown';

@Component({
  standalone: true,
  imports: [CommonModule, MatButtonModule, MarkdownModule],
  templateUrl: './dependent-value-modal.component.html',
  styleUrls: ['./dependent-value-modal.component.scss']
})
export class DependentValueModalComponent {
  public sourceValue: string = '';
  public tapeValue: string = '';

  constructor(
    private dialogRef: MatDialogRef<DependentValueModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.populateValuesFromData();
  }

  private populateValuesFromData() {
    if (!this.data) return;

    // If explicit ai_answer_list supplied, prefer categorized entries
    if (Array.isArray(this.data.ai_answer_list) && this.data.ai_answer_list.length > 0) {
      // If the list contains only manual entries, do not display them here
      const allManual = this.data.ai_answer_list.every((i: any) => (i.category || '').toString().toLowerCase().includes('manual'));
      if (allManual) return;
      // Prefer explicit categories
      const source = this.data.ai_answer_list.find((i: any) => (i.category || '').toString().toLowerCase().includes('source'));
      const tape = this.data.ai_answer_list.find((i: any) => (i.category || '').toString().toLowerCase().includes('tape'));

      if (source) this.sourceValue = source.result;
      if (tape) this.tapeValue = tape.result;

      // Fallback: pick first two non-manual entries (avoid showing manual inputs)
      if (!source || !tape) {
        const nonManual = this.data.ai_answer_list.filter((i: any) => !((i.category || '').toString().toLowerCase().includes('manual')));
        if (!source && nonManual[0]) this.sourceValue = nonManual[0].result;
        if (!tape && nonManual[1]) this.tapeValue = nonManual[1].result;
        // If still missing, fall back to any entries (last resort)
        if ((!source && !this.sourceValue) && this.data.ai_answer_list[0]) this.sourceValue = this.data.ai_answer_list[0].result;
        if ((!tape && !this.tapeValue) && this.data.ai_answer_list[1]) this.tapeValue = this.data.ai_answer_list[1].result;
      }
      return;
    }

    // Backward-compatibility: accept plain strings passed as `ai` / `tape`.
    if (typeof this.data.ai === 'string') this.sourceValue = this.data.ai;
    if (typeof this.data.tape === 'string') this.tapeValue = this.data.tape;
  }

  onClose() {
    this.dialogRef.close();
  }
}
